export enum ProcedureStepRedlineStatus{
    Pending = 'Pending',
    Incorperated = 'Incorperated',
    Rejected = 'Rejected',
}